(() => {
  const rewrite = (link) => {
    const value = link.getAttribute('href');
    if (!value) return;
    let url;
    try { url = new URL(value, window.location.origin); } catch { return; }
    if (url.origin !== window.location.origin) return;
    const match = url.pathname.match(/^(.*\/collections)\/all(?:\/.*)?$/);
    if (!match || /\/products\//.test(url.pathname)) return;
    link.setAttribute('href', match[1]);
  };
  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.matches('a[href]')) rewrite(root);
    root.querySelectorAll('a[href]').forEach(rewrite);
  };
  scan(document.documentElement);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') rewrite(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href'],
  });
})();
